"use client";

import { useEffect } from "react";
import { captureUtmParams } from "@/utils/analytics";

/**
 * UtmTracker component captures UTM parameters from the URL
 * and persists them in sessionStorage for attribution across the session.
 */
export default function UtmTracker() {
  useEffect(() => {
    captureUtmParams();
  }, []);

  return null;
}
